import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.15, ease: [0.25, 0.46, 0.45, 0.94] }
  })
};

const contactLinks = [
  { label: 'Email', icon: Mail, url: 'mailto:veerkotresh@gmail.com' },
  { label: 'GitHub', icon: FaGithub, url: 'https://github.com/kotresh75' },
  { label: 'LinkedIn', icon: FaLinkedin, url: 'https://www.linkedin.com/in/kotresh-c' },
  { label: 'Instagram', icon: FaInstagram, url: 'https://www.instagram.com/kotresh.c_' },
];

const Contact = () => {
  return (
    <section id="contact" className="section-wrapper">
      <motion.div
        className="section-header"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, margin: "-80px" }}
        variants={fadeUp}
        custom={0}
      >
        <span className="section-label">Contact</span>
        <h2 className="section-title">
          Let's <span className="gradient-text">Connect</span>
        </h2>
        <p className="section-subtitle">
          I'm always open to new opportunities, collaborations, and conversations.
          Feel free to reach out — let's build something great together.
        </p>
      </motion.div>

      <div className="contact-grid">
        {contactLinks.map((link, i) => (
          <motion.a
            key={i}
            href={link.url}
            target="_blank"
            rel="noreferrer"
            className="glass contact-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, margin: "-50px" }}
            variants={fadeUp}
            custom={i + 1}
          >
            <div className="contact-card-icon">
              <link.icon size={24} />
            </div>
            <span className="contact-card-label">{link.label}</span>
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default Contact;
